import { Injectable } from '@angular/core';
//import { Network } from '@ionic-native/network/ngx';//获取网络情况
import { Device } from '@ionic-native/device/ngx';//获取手机硬件设备
import { Platform,LoadingController } from '@ionic/angular';//获取是否手机
// import { HotCodePush } from '@ionic-native/hot-code-push/ngx';//热更新
import { Camera,CameraOptions } from '@ionic-native/camera/ngx';//相机
import { ImagePicker,ImagePickerOptions } from '@ionic-native/image-picker/ngx';//相册获取照片
import {MessageclientService} from '../service/messageclient.service';
// import { CallNumber } from '@ionic-native/call-number/ngx';//打电话
// import { SMS } from '@ionic-native/sms/ngx';//发送短信
import {CommonService} from './common.service';
import { Sim } from '@ionic-native/sim/ngx'; //获取sim卡信息
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
// import { HttpHeaders } from '@angular/common/http';
// import { HttpHeader } from '../service/static.service';
// import {InAppBrowser} from '@ionic-native/in-app-browser';
//  import { AppUpdate } from '@ionic-native/app-update/ngx';//安装android端APP
// import { ZBarOriginal, ZBarOptions } from '@ionic-native/zbar';//扫描二维码
import { WebResponesContext, WebParameterContext } from '../model/common';
import {File} from '@ionic-native/file/ngx';
import { Base64}  from '@ionic-native/base64/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import {AlertController } from '@ionic/angular'; 
// import { PhotoLibrary } from '@ionic-native/photo-library';
declare var app;
declare var imageConversion;
declare var IosSelect;
 
@Injectable({
  providedIn: 'root'
})
export class NativeService {

  constructor(
    //private network:Network,
    public device: Device,
    private platform: Platform,
    // private hot:HotCodePush,
    private camera: Camera,
    private imagePicker: ImagePicker,
    private msg: MessageclientService,
    // private callNumber: CallNumber,
    // private sms: SMS,
    private common: CommonService,
    private sim: Sim,
    private file:File,
    private transfer: FileTransfer,
    private base64:Base64,
    public fileOpener:FileOpener,
    public alert:AlertController,
    public loadCtr:LoadingController,
    // private photoLibrary:PhotoLibrary
    // private appUpdate:AppUpdate
    // private zbar:ZBarOriginal
   
    ) { }
  /**
   * 获取移动设备系统版本号 例如android:6.0
   */
  get GetVersion():string{
   return this.device.version;
  
  }
  
  /**
   * 获取移动设备的模型或产品名称
   */
  get GetModel(): string {
    return this.device.model || "";
  }
  /**
   * 获取移动设备制造商 例:huawei
   */
  get GetBrand(): string {
    return this.device.manufacturer || "";
  }
  /**
   * 获取移动设备操作系统名称 例:Android,ios,windows;
   */
  get GetSystem(): string {
    return this.device.platform || "";
  }
  /**
   * 获取移动设备序列号
   */
  get GetSerial(): string {
    return this.device.serial || "";
  }
  /**
   * 获取移动设备通用唯一标识uuid，例如：‘78ca1fe2c1d3b584’
   */
  get GetUUid(): string {
    return this.device.uuid || "";
  }
   /**
     * 是否真机环境,Android/ios(不包含移动端浏览器)
     * @return {boolean}
     */
    get isMobile(): boolean {
      return this.platform.is( 'cordova' );
    }
    /**
     * 是否移动端浏览器打开
     */
    get isMobileweb(): boolean {
      return this.platform.is( 'desktop' );
    }
  /**
   * 是否android真机环境
   * @return {boolean}
   */
  get isAndroid(): boolean {

    return this.platform.is( 'android' );
  }
  /**
   * 是否ios真机环境
   * @return {boolean}
   */
  get isIos(): boolean {
  

    return this.platform.is( 'ios' ) || this.platform.is( 'ipad' ) || this.platform.is( 'iphone' );
  }
  /**
   * 根据相机获取照片
   * @param _option 配置信息，参考CameraOptions实体类,使用方法导入:import {CameraOptions } from '@ionic-native/camera/ngx';
   */
  getCameraPicture(_option:CameraOptions={}):Promise<any>{
   const that =this;
    /**配置信息 */
    let options: CameraOptions = Object.assign({
      destinationType: that.camera.DestinationType.DATA_URL,
      encodingType: that.camera.EncodingType.JPEG,
      correctOrientation:true,//矫正拍照角度
      quality: 20,//图像质量，范围为0 - 100
      // targetWidth: 400,//缩放图像的宽度（像素）
      // targetHeight: 300,//缩放图像的高度（像素）
      mediaType: that.camera.MediaType.PICTURE,
      allowEdit: false,//选择图片前是否允许编辑
      saveToPhotoAlbum: false,//是否保存到相册
      // correctOrientation: true,//设置摄像机拍摄的图像是否为正确的方向
      sourceType:that.camera.PictureSourceType.CAMERA//拍照选择相机
    },_option);
    // console.log("pic");
    if(that.isMobile){
      return that.camera.getPicture(options);
    }else{
      return that.msg.ErrorMessage("非手机端不可使用");
    }
  }

    /**
   * 根据相机获取照片绝对地址
   * @param _option 配置信息，参考CameraOptions实体类,使用方法导入:import {CameraOptions } from '@ionic-native/camera/ngx';
   */
  getCameraPictureUrl(_option:CameraOptions={}):Promise<any>{
    const that =this;
     /**配置信息 */
     let options: CameraOptions = Object.assign({
       destinationType: that.camera.DestinationType.FILE_URI,
       encodingType: that.camera.EncodingType.JPEG,
       correctOrientation:true,//矫正拍照角度
       quality: 20,//图像质量，范围为0 - 100
       // targetWidth: 400,//缩放图像的宽度（像素）
       // targetHeight: 300,//缩放图像的高度（像素）
       mediaType: that.camera.MediaType.PICTURE,
       allowEdit: false,//选择图片前是否允许编辑
       saveToPhotoAlbum: false,//是否保存到相册
       // correctOrientation: true,//设置摄像机拍摄的图像是否为正确的方向
       sourceType:that.camera.PictureSourceType.CAMERA//拍照选择相机
     },_option);
     // console.log("pic");
     if(that.isMobile){
       return that.camera.getPicture(options);
     }else{
       return that.msg.ErrorMessage("非手机端不可使用");
     }
   }
  
  /**
   * 获取相册照片
   * @param options  配置信息，参考CameraOptions实体类,使用方法导入:import { ImagePickerOptions } from '@ionic-native/image-picker/ngx';
   */
  getPicture(options:CameraOptions={}):Promise<any>{
    options.sourceType = this.camera.PictureSourceType.PHOTOLIBRARY;
    options.destinationType = this.camera.DestinationType.FILE_URI;
    options.encodingType = this.camera.EncodingType.JPEG;
    options.quality = 20,//图像质量，范围为0 - 100
    // options.targetWidth = 1280;//缩放图像的宽度（像素）
    // options.targetHeight = 720;//缩放图像的高度（像素）
    options.mediaType = this.camera.MediaType.PICTURE;
    options.allowEdit =  true;//选择图片前是否允许编辑
    if(this.isMobile){
      return this.camera.getPicture(options);
    }else{
      return this.msg.ErrorMessage("非手机端不可使用");
    }
    
  }

    /**
   * 获取相册照片 返回base64
   * @param options  配置信息，参考CameraOptions实体类,使用方法导入:import { ImagePickerOptions } from '@ionic-native/image-picker/ngx';
   */
  getPictureBase64(options:CameraOptions={}):Promise<any>{
    options.sourceType = this.camera.PictureSourceType.PHOTOLIBRARY;
    options.destinationType = this.camera.DestinationType.DATA_URL;
    options.encodingType = this.camera.EncodingType.JPEG;
    options.quality = 20,//图像质量，范围为0 - 100
    // options.targetWidth = 300;//缩放图像的宽度（像素）
    // options.targetHeight = 300;//缩放图像的高度（像素）
    options.mediaType = this.camera.MediaType.PICTURE;
    options.allowEdit =  true;//选择图片前是否允许编辑
    if(this.isMobile){
      return this.camera.getPicture(options);
    }else{
      return this.msg.ErrorMessage("非手机端不可使用");
    }
    
  }
  /**
   * 获取多个文件
   */
  GetMuiltPicture():Promise<any>{
    const that= this;
    return new Promise<any>((jeson,reject)=>{
      that.imagePicker.requestReadPermission().then(data=>{
        let option:ImagePickerOptions = {};
        option.outputType = 0;
        return that.imagePicker.getPictures(option);
      }).catch(err0r=>{
        reject(err0r);
      });
    });
  }
  /**
   * 上传文件到服务器
   * @param FILE_URI 当前文件的地址
   */
  UploadPictures(FILE_URI:string):Promise<any>{
    const that = this;
    let transfer = new FileTransfer();
    const fileTransfer: FileTransferObject = transfer.create();
   let options: FileUploadOptions = {
      fileKey: 'file',
      fileName: 'name.jpg',
      // mimeType: "image/jpeg",
      httpMethod: "post",
      headers:null
   };
      // options.headers = that.getHttpHeaders();
      if(FILE_URI.indexOf('?')>=0){
        FILE_URI = FILE_URI.substr(0,FILE_URI.lastIndexOf('?'));
      }
      options.fileName=FILE_URI.substr(FILE_URI.lastIndexOf('/')+1);
      //console.log("文件上传");
      return new Promise<any>((resolve,reason)=>{
        fileTransfer.upload(FILE_URI,app.UPLOADURL,options).then(data=>{
         // console.log("文件上传10");
          if(data.responseCode == 200){
            let message = JSON.parse(data.response);
            if(message.ResponseMessage.Success){
              message.Status.forEach((element,index) => {
                message.Status[index].FileHostName = app.WEBSITE+element.FileHostName;
              });
            }
            resolve(message);
          }
       }).catch(error=>{
         console.log(error);
         reason(error);
         that.msg.Show("上传失败,请联系管理员");
       });
      });
  }
   /**
   * 文件上传
   * @param FILE_URI 需要上传的文件路径
   * @param obj 需要传递的参数
   * @param mimeType 文件mimeType类型 默认'image/jpeg'
   */
  UploadFile(FILE_URI:string,obj:any={},mimeType:any="image/jpeg"):Promise<any>{
    const that = this;
    return new Promise<any>((resolve,reason)=>{
      let transfer = new FileTransfer();
      const fileTransfer: FileTransferObject = transfer.create();
      let options: FileUploadOptions = {
          httpMethod: "post",
          headers:null
      };
      options.mimeType=mimeType;//文件mimeType类型
         let index:number= FILE_URI.lastIndexOf("\/")+1;
         let filesname = FILE_URI.substring(index,FILE_URI.length);//获取文件名称
          options.fileName=filesname;
          obj["FileName"]=filesname;
      options.params={"RequestBody":JSON.stringify(obj)};
      fileTransfer.upload(FILE_URI,app.UPLOADURL,options).then(data=>{
        if(data.responseCode == 200){
          let message = JSON.parse(data.response);
          if(message.ResponseMessage.Success){
            message.Status.forEach((element,index) => {
              message.Status[index].FileHostName = app.WEBSITE+element.FileHostName;
            });
          }
          resolve(message);
        }
     }).catch(error=>{
       console.log(error);
       reason(error);
      //  that.msg.Show("上传失败,请联系管理员");
     });

    });
  }
  /**
   * 同步压缩图片上传
   * @param imageUrl 返回base64位图片字符串
   * @param imageType 文件类型，1：jpg;2:png
   * @param size 压缩大小
   * @param params 参数 默认{}
   */
  CompressAccurately(imageUrl:string,imageType:number = 1, size:number = 600,params:any={} ){
    const that= this;
    let imgtype="image/jpeg";
    if(imageType==2){
      imgtype="image/png";
    }
    let ext = ".jpg";
    if(imageType==2){
      ext=".png";
    }     
    let imgName = that.GetImgFileName();   
    let FileName = "["+imgName+"]"+imgName+".jpg";
    let isf:boolean = false;
    if(that.platform.is("cordova")){
      if(that.platform.is("android")){//android系统手机
        if(that.device.version){//版本号存在
          if(that.device.version.toString().startsWith("5")){//当前版本小于等于5.0
            isf=true;
          }else if(that.device.version.toString().startsWith("4")){//当前版本小于等于4.0
            isf=true;
          }else if(that.device.version.toString().startsWith("3")){//当前版本小于等于3.0
            isf=true;
          }
        }
      }
    }
    // console.log(imageType);
    return new Promise<any>((resolve,reject)=>{
         
      if(!isf){
        imageConversion.dataURLtoFile(imageUrl,imgtype).then(file=>{
          imageConversion.compressAccurately(file, size).then(blob => {
           
            that.RequestFormData(app.UPLOADURL,blob,ext,FileName,false,params).then(data=>{
              resolve(data);
            }).catch(error=>{
              reject(error);
            });                                                     
          });
        });
    }else{
      that.RequestFormData(app.UPLOADURL,imageUrl,ext,FileName,true,params).then(data=>{
        resolve(data);
      }).catch(error=>{
        reject(error);
      });  
    }
    });
  }
  /**
   * 文件上传
   * @param url  文件上传api地址
   * @param file  文件地址,64位地址或者文件路劲地址
   * @param ext 文件类型
   * @param fileName 文件名称
   * @param isbase64 是否64位字符串，默认false
   * @param parmars 需要传递的参数 默认{}
   */
  RequestFormData(url:any,file:any,ext:string,fileName:string,isbase64:boolean=false,parmars:any={}):Promise<any>{
    const that =this;
    // console.log("上传图片");
    return new Promise<any>((resolve,reject)=>{
      let Msg = new WebResponesContext();
      Msg.ResponseMessage.Success = false;
      Msg.ResponseMessage.ErrorMessage = app.ERRORMESSAGE;

      let formData = new FormData();                                 
      formData.append('files',file,new Date().getTime() + ext);
      let store = that.common.GetStorageKey("tbstore");
      let obj:any={};
          obj["FileName"]=fileName;
          if(store){//门店地址
            obj["storeId"]=store.ID;
          }
          if(isbase64){//64位字符串
            obj["base64"]=file;
          }
          obj=Object.assign(parmars,obj);
          formData.append('RequestBody',JSON.stringify(obj));
     
      try{
        var request = new XMLHttpRequest();
        // request.setRequestHeader("Content-Type","multipart/form-data; charset=UTF-8");
        request.open('post',url,true);
        // request.setRequestHeader('Authorization',"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiU0EiLCJJRCI6ImIxYTAzYjMzLThjOGEtNDZjYS04MDRjLTE2NmJmNWIxNDY5YSIsIkRpc3BsYXlOYW1lIjoi6ZSA5ZSu5Luj6KGoIiwiTG9naW5OYW1lIjoiU0EiLCJBcHAiOiJ0cnVlIiwianRpIjoiYjFhMDNiMzMtOGM4YS00NmNhLTgwNGMtMTY2YmY1YjE0NjlhIiwiaWF0IjoiMjAxOS80LzE4IDI6NDU6MjMiLCJuYmYiOjE1NTU1NTU1MjMsImV4cCI6MTU1NTY0MTkyMywiaXNzIjoiaHR0cDovL3d3dy5tb2Jpem9uZS5jbiIsImF1ZCI6Ind3dy5tb2Jpem9uZS5jbiJ9.yGhPdG_90bdr8o8WDjneYdvQ6B4ysk_22Yxw8ZETHFg");
        request.send(formData);
        request.onload = function(data){
          if(data.currentTarget['status'] == 200){
            console.log("上传成功");
            const body = JSON.parse(data.currentTarget['response']);
            if (body.ResponseMessage.Success) {
                Msg.ResponseMessage.Success=true;
                Msg.Status = body.Status;
            } 
            resolve(Msg);
          }else{
            console.log("上传失败");
            reject(Msg);
            // that.msg.Alert("图片上传失败");
          }
        }
      }catch(error){
        reject(Msg);
      }
    });
  }
  /**
   * 异步压缩图片上传
   * @param imageUrl 返回base64位图片字符串
   * @param imageType 文件类型，1：jpg;2:png
   * @param size 压缩大小
   * @param postType 上传地址,1表示异步,2同步
   * @param params 参数 默认{}
   */
  AsyncCompressAccurately(imageUrl:string, imageType:number=1,size:number=600,postType=1,params:any={}){
    const that = this;
    //此功能为了进店加水印 20210501
    // if(location.href.indexOf("VisitIn")!=-1){
    // postType=2;//必须为同步（1为异步  2为同步）
    // }
    // if(location.href.indexOf("TBDetainSingleXML")!=-1){
    //   postType=2;//必须为同步（1为异步  2为同步）
    //   }
    // if(location.href.indexOf("DisplayCheck")!=-1){
    //   postType=2;//必须为同步（1为异步  2为同步）
    //   }
    postType=2;
    return new Promise<any>((resolve,reject)=>{
      let imgtype = "image/jpeg";
    if(imageType == 2){
      imgtype="image/png";
    }
    let imgName = that.GetImgFileName();   
    let FileName = "["+imgName+"]"+imgName+".jpg";
    let imgNameArr = "placeholder/uploads/image/"+FileName;
    console.log("活动检查上传图片",params["ConfigName"]);
    if(typeof(params["ConfigName"])!="undefined"){
      if(params["ConfigName"]=="actityInspen"){
        imgNameArr="placeholder/uploads/ActityPhoto/"+FileName;
      }
      
      //公用 活动检查 陈列拍照参数  kk20210415
      let _store=localStorage.getItem("tbstore");
      if(_store)
      {
        params["FK_TBStore_ID"]=JSON.parse(_store)["ID"]||"";
        params["StoreName"]=JSON.parse(_store)["name"]||"";
        params["StoreCode"]=JSON.parse(_store)["code"]||"";
      }
      params["UserName"]=that.common.GetAccount.DisplayName;

      params["UserCustomerID"]=that.common.GetAccount.CustomerID;
      params["FK_SystemUser_ID"]=that.common.GetAccount.Id;
      params["UserAlias"]=that.common.GetAccount.LoginName;
      console.log("kk 陈列拍照");
        let _photoTypeData=localStorage.getItem("TBPhotoType_storage");
        let _photoTypeList=[];
        if(_photoTypeData)
        {
          _photoTypeList=JSON.parse(_photoTypeData);
          //不是进店的时候
          if(_photoTypeList.length>0&&params["ConfigName"]!="TBDetainSingleXML")
          {
            let instore=_photoTypeList.find(n=>n.a_ConfigName===params["ConfigName"])||{};
            // let instore=_photoTypeList.find(n=>n.a_Code=="A1004")||{};
            params["TBPhotoTypeName"]=instore["a_Name"]||"";
            params["TBPhotoTypeCode"]=instore["a_Code"]||"";
            params["TBPhotoTypeID"]=instore["a_ID"]||"";
          }
        }
         
      // //活动检查拍照
      // console.log("kk 活动检查拍照");
      // if(location.href.indexOf("activityform")!=-1){
      //   params["ConfigName"]="TBDetainSingleXML";
       
      //   let _photoTypeData=localStorage.getItem("TBPhotoType_storage");
      //   let _photoTypeList=[];
      //   if(_photoTypeData)
      //   {
      //     _photoTypeList=JSON.parse(_photoTypeData);
      //     if(_photoTypeList.length>0)
      //     {
      //       params["TBPhotoTypeCode"]="A1003";
      //       let instore=_photoTypeList.find(n=>n.a_Code=="A1003")||{};
      //       params["TBPhotoTypeName"]=instore["a_Name"]||"";
      //       params["TBPhotoTypeID"]=instore["a_ID"]||"";
      //     }
      //   }
         
      // }
      //  //陈列拍照
      // //  location.href.indexOf("DisplayCheck1")
      //  console.log("kk 陈列拍照");
      //  if(location.href.indexOf("DisplayCheck")!=-1){
      //    params["ConfigName"]="TBDetainSingleXML";
      //    let _photoTypeData=localStorage.getItem("TBPhotoType_storage");
      //    let _photoTypeList=[];
      //    if(_photoTypeData)
      //    {
      //      _photoTypeList=JSON.parse(_photoTypeData);
      //      if(_photoTypeList.length>0)
      //      {
      //        params["TBPhotoTypeCode"]="A1004";
      //        let instore=_photoTypeList.find(n=>n.a_Code=="A1004")||{};
      //        params["TBPhotoTypeName"]=instore["a_Name"]||"";
      //        params["TBPhotoTypeID"]=instore["a_ID"]||"";
      //      }
      //    }
          
      //  }
    }
    debugger;
    
    let ext = ".jpg";
    if(imageType==2){
      ext=".png";
    }   
    let url=app.UPLOADURLSYNC;//UPLOADURL;
    if(postType==1){
      url=app.UPLOADURLSYNC;
    }else if(postType==2){//同步
      url=app.UPLOADURL;
    }   
    // let isf:boolean = false;
    let isf:boolean = false;
    if(that.platform.is("cordova")){
      if(that.platform.is("android")){//android系统手机
        if(that.device.version){//版本号存在
          if(that.device.version.toString().startsWith("5")){//当前版本小于等于5.0
            isf=true;
          }else if(that.device.version.toString().startsWith("4")){//当前版本小于等于4.0
            isf=true;
          }else if(that.device.version.toString().startsWith("3")){//当前版本小于等于3.0
            isf=true;
          }
        }
      }
    }
      isf=true;
      if(isf){
        that.RequestFormData(url,imageUrl,ext,FileName,true,params).then(data=>{
          resolve(data);
        }).catch(error=>{
          reject(error);
        }); 
      }else{
        try{
          imageConversion.dataURLtoFile(imageUrl,imgtype).then((file)=>{
            imageConversion.compressAccurately(file, size).then(blob => {
              that.RequestFormData(url,blob,ext,FileName,false,params).then(data=>{
                resolve(data);
              }).catch(error=>{
                reject(error);
              }); 
            }).catch(err=>{
              reject(err);
            });;
          }).catch(err=>{
            reject(err);
          });
        }catch(err){
          that.RequestFormData(url,imageUrl,ext,FileName,true,params).then(data=>{
            resolve(data);
          }).catch(error=>{
            reject(error);
          }); 
        }
      }
      if(postType==1){//表示异步,先返回结果
        let Msg = new WebResponesContext();
          Msg.ResponseMessage.Success = true;
          Msg.ResponseMessage.ErrorMessage = app.ERRORMESSAGE;
          Msg.Status=new Array<any>();
          Msg.Status.push({"FileName":imgNameArr})
        resolve(Msg);
      }
    });
  }

  getBase64Image(img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, img.width, img.height);
    var ext = img.src.substring(img.src.lastIndexOf(".")+1).toLowerCase();
    // var ext=img.src;
    var dataURL = canvas.toDataURL("image/"+ext);
    return dataURL;
}
  /**
   * 异步图片上传名称
   */
  GetImgFileName(){
    let date:Date = new Date();
    let year,month,day;
    let riqi = date.getFullYear().toString().substring(2,4);
    let tmp1:any = date.getMonth()+1;
    let tmp2:any =  date.getDate();
    month=tmp1;
    day = tmp2;
    if(tmp1 <10){
      month = "0"+tmp1;
    }
    if(tmp2<10){
      day = "0"+tmp2;
    }
    year = riqi;
    return year+month+day+date.getHours()+date.getMinutes()+date.getSeconds()+date.getMilliseconds();
  }
   /**
  * 下载安装app
  */
 downloadApp(url:any=null) {
  let that = this;
   that.msg.Loading("下载进度：0%").then((loads:HTMLIonLoadingElement)=>{
      let transfer = new FileTransfer();
      const fileTransfer:FileTransferObject = transfer.create();
      //const apk = this.file.externalRootDirectory + 'android.apk'; //apk保存的目录
      let apk = that.file.externalDataDirectory + 'android.apk';
      let fileupload:any = "";
      if(url){
        fileupload = url;
      }else{
          if(!app.RELEASE){//测试地址
            apk = that.file.externalDataDirectory + 'androidtest.apk';
            fileupload = app.DOWNLOAD_ANDROID_URL_TEST;
          }else{
              fileupload = app.DOWNLOAD_ANDROID_URL;
          }
      }
     
      fileTransfer.download(fileupload, apk ).then(( datas ) => {
        that.fileOpener.open(apk, "application/vnd.android.package-archive" )
          .then( success => {
            loads.dismiss();
            console.log( success );
          }, error => {
            loads.dismiss();
            console.log( error );
          })
          .catch( error => {
            loads.dismiss();
            that.msg.Alert(app.ERRORMESSAGE);
            console.log( error );
          } );
      }).catch( error => {
        loads.dismiss();
        that.msg.Alert(app.ERRORMESSAGE);
      });
      console.log(loads);
      fileTransfer.onProgress(( event: ProgressEvent ) => {
        let num = Math.floor( event.loaded / event.total * 100 );
        if ( num === 100 )
        {
          loads.message = '下载完成准备安装,请稍后';
          loads.dismiss();
        } else
        {
          console.log(loads);
          let title = num;
          title && ( loads.message = '下载进度：' + num + '%' );
        }
      });
      loads.present();
    });
}
/**
 * 上传文件到服务器
 * @param fileU 需要上传的文件
 * @param parmars 需要上传的参数
 * @param apiUrl 服务器地址
 */
UploadFileLoading(file:string,parmars:any={},apiUrl:string=app.UPLOADURL)
{
  let that=this;
  return  new Promise<WebResponesContext>((resolve,reject)=>{
    console.log(apiUrl,"url");
  console.log(file,"file");
    if(apiUrl){apiUrl = app.UPLOADURL};
       let msg:any="已上传";
    that.msg.Loading(msg).then((loads:HTMLIonLoadingElement)=>{
      let transfer = new FileTransfer();
      const fileTransfer:FileTransferObject = transfer.create();
     let WebContext:WebResponesContext=new WebResponesContext();
      // let fileupload:any =file;
      // let index:number= file.lastIndexOf("\/")+1;
      // let filesname = file.substring(index,file.length);//获取文件名称
      // let apk = that.file.cacheDirectory + filesname;
      let options: FileUploadOptions = {
          httpMethod: "post",
          headers:null
      };
      let requestBody={};
      let imgName = that.GetImgFileName();   //获取照片名称随机字符
      let imgtype:any=parmars.TBProductBrand_ID;
      if(parmars.Code){
        imgtype=parmars.Code;
      }
      let FileName = "["+imgtype+"]["+imgName+"]"+imgName+".jpg";//拼接照片名称
               parmars["FileName"]=FileName;
               console.log("kk 陈列拍照");
               if(location.href.indexOf("DisplayCheck")!=-1){
                parmars["ConfigName"]="TBDetainSingleXML";
                 let _photoTypeData=localStorage.getItem("TBPhotoType_storage");
                 let _photoTypeList=[];
                 if(_photoTypeData)
                 {
                   _photoTypeList=JSON.parse(_photoTypeData);
                   if(_photoTypeList.length>0)
                   {
                    parmars["TBPhotoTypeCode"]="A1004";
                     let instore=_photoTypeList.find(n=>n.a_Code=="A1004")||{};
                     parmars["TBPhotoTypeName"]=instore["a_Name"]||"";
                     parmars["TBPhotoTypeID"]=instore["a_ID"]||"";
                   }
                 }
                  
               }
               console.log("kk 陈列拍照");//end
        requestBody["RequestBody"] = JSON.stringify(parmars);
         options.params=requestBody;
      fileTransfer.upload(file,apiUrl,options).then(data=>{
        loads.dismiss();
        console.log("连拍返回的参数 陈列检查或分销displayorfx",data);

        if(data.responseCode == 200){
          let message = JSON.parse(data.response);
               WebContext = message;
        }else{
          WebContext.ResponseMessage.Success=false;
          WebContext.ResponseMessage.ErrorMessage=app.ERRORMESSAGE;
        }
        resolve(WebContext);
     }).catch(error=>{
       loads.dismiss();
       console.log(error);
       WebContext.ResponseMessage.Success=false;
       WebContext.ResponseMessage.ErrorMessage=app.ERRORMESSAGE;
       reject(WebContext);
      //  that.msg.Show("上传失败,请联系管理员");
     });
      fileTransfer.onProgress(( event: ProgressEvent ) => {
        let num = Math.floor( event.loaded / event.total * 100 );
        if ( num === 100 ) {
          loads.message = '上传完成';
          loads.dismiss();
        } else{
          let title = num;
          title && ( loads.message = msg + num + '%' );
        }
      });
      loads.present();
    });
  });
}
/**
 * 打开文件
 * @param fileUrl 文件地址 https://xxxxxxxx.com.cn/xx.pdf
 * @param target 文件类型,默认为"application/pdf";
 */
OpenFile(fileUrl:string,target:string="application/pdf"){
  let that = this;
   that.msg.Loading("下载进度：0%").then((loads:HTMLIonLoadingElement)=>{
      let transfer = new FileTransfer();
      const fileTransfer:FileTransferObject = transfer.create();
      //const apk = this.file.externalRootDirectory + 'android.apk'; //apk保存的目录
      
      let fileupload:any =fileUrl;
      let index:number= fileUrl.lastIndexOf("\/")+1;
      let filesname = fileUrl.substring(index,fileUrl.length);//获取文件名称
      let apk = that.file.dataDirectory  + filesname;
      let headers = {};
          headers["Content-type"]="application/octet-stream";
          headers["Content-Disposition"]="attachment;filename="+filesname;
      fileTransfer.download(fileupload, apk,true,headers ).then(( datas ) => {
        that.fileOpener.open(datas.nativeURL, target)
          .then( success => {
            loads.dismiss();
            console.log( success );
          }, error => {
            loads.dismiss();
            console.log( error );
          })
          .catch( error => {
            loads.dismiss();
            that.msg.Alert(app.ERRORMESSAGE);
            console.log( error );
          } );
      }).catch( error => {
        loads.dismiss();
        that.msg.Alert(app.ERRORMESSAGE);
      });
      console.log(loads);
      fileTransfer.onProgress(( event: ProgressEvent ) => {
        let num = Math.floor( event.loaded / event.total * 100 );
        if ( num === 100 )
        {
          loads.message = '下载完成准备打开中,请稍后';
          loads.dismiss();
        } else
        {
          //console.log(loads);
          let title = num;
          title && ( loads.message = '下载进度：' + num + '%' );
        }
      });
      loads.present();
    });

}


  /**
   * 
   * @param imageUrl 改变图片路径为64位
   */
  Base64File(imageUrl:any):Promise<any>{
    const that= this;
    return new Promise<any>((resolve,reject)=>{
      that.base64.encodeFile(imageUrl).then(data=>{
        console.log(data);
        resolve(data);
      }).catch(err=>{
         console.log(err);
         reject(err);
      });
    });
    
  }
  /**
   * 拨打电话
   * @param _number 电话号码
   */
  GetCallPhone(_number:string){
    // if(this.isMobile){
    //   return this.callNumber.callNumber(_number,true);
    // }else{
    //   return new Promise<string>((resolve,reject)=>{
    //     document.location.href='tel:'+_number;
    //     resolve("成功");
    //   })
    //   //return this.msg.ErrorMessage("非手机端不可使用");
    // }
    return new Promise<string>((resolve,reject)=>{
      document.location.href='tel:'+_number;
      resolve("成功");
    })
    
  }
  /**
   * 发送短信
   * @param phoneNumber 接收的手机号码
   * @param _message 短信内容
   */
  GetSendMsg(phoneNumber:any,_message:string){
    let that=this;
    // if(that.isMobile){
    //   return that.sms.send(phoneNumber,_message);
    // }else{
    //   return new Promise<any>((resolve,reject)=>{
    //     if(that.common.BrowserRedirect==="maxos"){
    //       document.location.href='sms:'+phoneNumber+'&body='+_message;
    //     }else{
    //       document.location.href='sms:'+phoneNumber+'?body='+_message;
    //     }
    //     resolve("成功");
    //   });
       
    //   //return this.msg.ErrorMessage("非手机端不可使用");
    // }
    return new Promise<any>((resolve,reject)=>{
      if(that.common.BrowserRedirect==="maxos"){
        document.location.href='sms:'+phoneNumber+'&body='+_message;
      }else{
        document.location.href='sms:'+phoneNumber+'?body='+_message;
      }
      resolve("成功");
    });
  }

  /**
   * 更新android端App,参考地址:https://beta.ionicframework.com/docs/native/app-update
   *   ---------------实例--------------------
   * <update>
   * <version>302048</version>
   * <name>APK Name</name>
   * <url>https://your-remote-api.com/YourApp.apk</url>
   * </update>
   * @param updateUrl xml地址
   */
  // getUpdateApp(updateUrl:string){
  //   if(this.isMobile && this.isAndroid){
  //     return this.appUpdate.checkAppUpdate(updateUrl);
  //   }else{
  //     return new Promise((DATA_URL)=>{
  //       return "非手机端不支持此功能"
  //     });
  //   }
  // }
  /**
   * 扫码
   */
  // getScandCode(){
  //   let option: ZBarOptions = {
  //     flash: 'off',
  //     text_title: '扫码',
  //     drawSight: false
  //   };
  //  return this.zbar.scan(option);
  // }
  // 观察网络断开
// public disconnectSubscription = this.network.onDisconnect().subscribe(() => {
//   console.log('network was disconnected :-(');
// });

// // stop disconnect watch
// disconnectSubscription.unsubscribe();


// // 观察网络连接
// public connectSubscription = this.network.onConnect().subscribe(() => {
//   console.log('network connected!');
//   // We just got a connection but we need to wait briefly
//    // before we determine the connection type. Might need to wait.
//   // prior to doing any api requests as well.
//   setTimeout(() => {
//     if (this.network.type === 'wifi') {
//       console.log('we got a wifi connection, woohoo!');
//     }
//   }, 3000);
// });

// // 断开网络
// connectSubscription.unsubscribe();
/**
 * 获取sim信息
 */
get PhoneNumber():Promise<any>{
  const that = this;
  return new Promise<any>((resolve,reject)=>{
    if(that.isMobile){
      that.sim.getSimInfo().then(data=>{
        resolve(data);
        }).catch(error=>{
          reject(error);
        });
    }else{
      resolve("");
    }
   });
  }
  /**
   * 
   * ****************************************************************调用方式***********************************************
   * 
   * this.nativeservice.IosselectDateTime({"format":"default","value":"2018-8-23 23:59:59"}).then(data=>{
      console.log(data);
    }).catch(err=>{
      console.log(err);
    });
   * 
   * 
   * 
   */
 /**
  * 日期下拉控件
  * @param config  表示一个对象,其中 type:default-默认”年月日时分秒“，”yyyymmdd“，”yyyymm“,"hhmmss","hhmm";默认"default";
  * （其中:Y表示”年“，m表示”月“，d表示”天“，”h“表示小时，”m“表示分钟过，”s“表示秒。）
  * “value”：表示选中的值，默认当前年月日。
  */
  IosselectDateTime(config:any={}):Promise<any>{
    const that =this;
    let now = new Date();
       let values = now.getFullYear()+"-"+(now.getMonth() + 1)+"-"+now.getDate()+" "+now.getHours()+":"+now.getMinutes()+":"+now.getSeconds();
        config = Object.assign({"format":"default","value":values},config);
    // console.log(config);
    let arrayData:any;
      let oneLevelId:any = "";//now.getFullYear();
      let twoLevelId:any = "";//now.getMonth() + 1;
      let threeLevelId:any = "";//now.getDate();
      let fourLevelId:any ="";// now.getHours();
      let fiveLevelId:any ="";// now.getMinutes();
      let sixLevelId:any = "";//now.getSeconds();
    let year =that.common.FormatYear;
    let month =that.common.FormatMonth;
    let hours =that.common.GetHourData;
    let minutes =that.common.GetMinuteData;
    let seconds =that.common.GetSecondsData;
    let countTime:number = 6;
         /**
       * 关联月份
       * @param year 
       * @param month 
       */
      let  GetDateDay=function (year, month, callback) {
        if (/^(1|3|5|7|8|10|12)$/.test(month)) {
            callback(that.common.FormatDate(31));
        }
        else if (/^(4|6|9|11)$/.test(month)) {
            callback(that.common.FormatDate(30));
        }
        else if (/^2$/.test(month)) {
            if (year % 4 === 0 && year % 100 !==0 || year % 400 === 0) {
                callback(that.common.FormatDate(29));
            }
            else {
                callback(that.common.FormatDate(28));
            }
        }
        else {
            throw new Error('month is illegal');
        }
    };
    arrayData=[year,month,GetDateDay,hours,minutes,seconds];
    if(config.value){
      let datavalue=that.common.FormatDateData(config.format,config.value);
      if(datavalue.length>0){
        
        if(datavalue[0]){
          oneLevelId = datavalue[0].toString();
        }
        if(datavalue[1]){
          twoLevelId = datavalue[1].toString();
        }
        if(datavalue[2]){
          threeLevelId = datavalue[2].toString();
        }
        if(datavalue[3]){
          fourLevelId = datavalue[3].toString();
        }
        if(datavalue[4]){
          fiveLevelId = datavalue[4].toString();
        }
        if(datavalue[5]){
          sixLevelId = datavalue[5].toString();
        }
      }
    }else{
      switch(config.format){
        case "yyyymmdd"://年月日
        oneLevelId = now.getFullYear();
        twoLevelId = now.getMonth() + 1;
        threeLevelId = now.getDate();
          break;
          case "yyyymm"://年月
          oneLevelId = now.getFullYear();
          twoLevelId = now.getMonth() + 1;
          break;
          case "hhmmss"://时分秒
          fourLevelId = now.getHours();
          fiveLevelId = now.getMinutes();
          sixLevelId = now.getSeconds();
            break;
            case "hhmm"://时分
            fourLevelId = now.getHours();
            fiveLevelId = now.getMinutes();
            break;
            case "default":
            case "yyyymmddhhmmss":
                oneLevelId = now.getFullYear();
                twoLevelId = now.getMonth() + 1;
                threeLevelId = now.getDate();
                fourLevelId = now.getHours();
                fiveLevelId = now.getMinutes();
                sixLevelId = now.getSeconds();
              break;
  
      }
    }
    switch(config.format){
      case "yyyymmdd"://年月日
          countTime = 3;
          arrayData=[year,month,GetDateDay];
        break;
        case "yyyymm"://年月
          countTime = 2;
          arrayData=[year,month];
        break;
        case "hhmmss"://时分秒
            countTime = 3;
            arrayData=[hours,minutes,seconds];
          break;
          case "hhmm"://时分
            countTime = 2;
            arrayData=[hours,minutes];
          break;

    }

    return new Promise<any>((resolve,reject)=>{
      new IosSelect(countTime,arrayData,{
        title: '日期选择',
        itemHeight: 35,
        itemShowCount: 9,
        oneLevelId: oneLevelId,
        twoLevelId: twoLevelId,
        threeLevelId: threeLevelId,
        fourLevelId: fourLevelId,
        fiveLevelId: fiveLevelId,
        sixLevelId: sixLevelId,
        callback:function(selectOneObj, selectTwoObj, selectThreeObj, selectFourObj, selectFiveObj, selectSixObj){
          let obj={};
            // obj["year"]=selectOneObj;
            // obj["month"]=selectTwoObj;
            // obj["day"]=selectThreeObj;
            // obj["hours"]=selectFourObj;
            // obj["minutes"]=selectFiveObj;
            // obj["seconds"]=selectSixObj;
            // console.log(obj);
            switch(config.format){
              case "yyyymmdd"://年月日
                obj["value"]=selectOneObj.id+"-"+selectTwoObj.id+"-"+selectThreeObj.id;
                obj["text"]=selectOneObj.value+selectTwoObj.value+selectThreeObj.value;
                break;
                case "yyyymm"://年月
                obj["value"]=selectOneObj.id+"-"+selectTwoObj.id;
                obj["text"]=selectOneObj.value+selectTwoObj.value;
                
                break;
                case "hhmmss"://时分秒
                obj["value"]=selectOneObj.id+":"+selectTwoObj.id+":"+selectThreeObj.id;
                obj["text"]=selectOneObj.value+selectTwoObj.value+selectThreeObj.id;
                  break;
                  case "hhmm"://时分
                  obj["value"]=selectOneObj.id+":"+selectTwoObj.id;
                  obj["text"]=selectOneObj.value+selectTwoObj.value;
                  break;
                  case "default":
                  case "yyyymmddhhmmss":
                      obj["value"]=selectOneObj.id+"-"+selectTwoObj.id+"-"+selectThreeObj.id+" "+selectFourObj.id+":"+selectFiveObj.id+":"+selectSixObj.id;
                      obj["text"]=selectOneObj.value+selectTwoObj.value+selectThreeObj.value+selectFourObj.value+selectFiveObj.value+selectSixObj.value;
                    break;
            }
          resolve(obj);
        },
        fallback: function () {
          let _errobj={};
          _errobj["message"]="取消";
          _errobj["type"]="cancel"
          reject(_errobj);
          },
         maskCallback: function () {
                    let _errobj={};
                    _errobj["type"]="colse"
                    _errobj["message"]="关闭";
                    reject(_errobj);
         }
      });
    });
  }
  /**
 * 同步日志
 * @param fileUrl 同步文件路劲，默认手机app安装目录
 * @param mimeType 文件mimeType类型 默认:"text/plain"
 */
LogSyn(fileUrl:any=null,mimeType:any="text/plain"){
  const that =this;
          if(that.platform.is("cordova")){
            if(!fileUrl){//如果文件路劲不存在则默认地址
                  fileUrl=that.file.tempDirectory;//默认ios临时目录
                if(that.platform.is("android"))
                {
                  fileUrl=that.file.externalCacheDirectory;//android
                }
                  fileUrl=fileUrl+that.common.getNow+".txt";
             }
                let parms={};
                  let tbstoreID="";
                  if(that.common.GetStorageKey("tbstore")){
                    tbstoreID=that.common.GetStorageKey("tbstore").ID;
                  }
                  parms["storeId"]=tbstoreID;
                  parms["TBProductBrand_ID"]=that.common.GetAccount.Id;//类型ID
                  parms["SavePath"]="uploads/AppError";//分类类型
                  that.UploadFile(fileUrl,parms,mimeType).then(data=>{
                     console.log("文件同步成功");
                  }).catch(err=>{
                    console.log("文件同步失败");
                  });
                
          }else{
            console.log("手机端可用");
          }
   
}


   /**
   * 根据相册获取照片绝对地址
   * @param _option 配置信息，参考CameraOptions实体类,使用方法导入:import {ImagePickerOptions } from '@ionic-native/image-picker/ngx';
   */
  getImagePickerUrl(_option:CameraOptions={}):Promise<any>{
    const that =this;
    console.log(_option,"拍照参数");
     /**配置信息 */
     let options: CameraOptions = Object.assign({
       sourceType:that.camera.PictureSourceType.PHOTOLIBRARY,//拍照选择相机
       destinationType: that.camera.DestinationType.FILE_URI,
       encodingType: that.camera.EncodingType.JPEG,
       quality: 10,//图像质量，范围为0 - 100
       // targetWidth: 400,//缩放图像的宽度（像素）
       // targetHeight: 300,//缩放图像的高度（像素）
       mediaType: that.camera.MediaType.PICTURE,
       allowEdit: false,//选择图片前是否允许编辑
       // correctOrientation: true,//设置摄像机拍摄的图像是否为正确的方向
     },_option);
     // console.log("pic");
     if(that.isMobile){
       return that.camera.getPicture(options);
     }else{
       return that.msg.ErrorMessage("非手机端不可使用");
     }
   }

   gmiImgFiledownload(fileUrl:any="",fileType:any="image/jpeg") {
    //  debugger;
    // const fileTransfer: FileTransferObject = this.transfer.create();
    // console.log("gmibaocunchengsaleinto_okFileTransferObject",fileTransfer);
    // const url ="http://www.example.com/file.pdf";
    // fileTransfer.download(fileUrl, this.file.dataDirectory +this.common.getNowDatetime+ fileType).then((entry) => {
    //   console.log("gmibaocunchengsaleinto_ok",entry);
    // }, (error) => {
    //   alert("download失败")
    // });
    let imageName = "FreakyJolly.jpg";
    imageName=fileUrl;
    const ROOT_DIRECTORY = 'file:///sdcard//';
    const downloadFolderName = 'tempDownloadFolder';
    debugger;
    // this.photoLibrary.saveImage(fileUrl,'saleinto').then(()=>{
    //   alert('保存成功');
    // }).catch((error) => {
    //   alert('error' + JSON.stringify(error));
    // });
 
    
    //Create a folder in memory location
    this.file.createDir(ROOT_DIRECTORY, downloadFolderName, true)
      .then((entries) => {

        //Copy our asset/img/FreakyJolly.jpg to folder we created
        this.file.copyFile(imageName, imageName, ROOT_DIRECTORY + downloadFolderName + '//', imageName)
          .then((entries) => {

            //Open copied file in device's default viewer
            this.fileOpener.open(ROOT_DIRECTORY + downloadFolderName + "/" + imageName, 'image/jpeg')
              .then(() => console.log('File is opened'))
              .catch(e => alert('Error' + JSON.stringify(e)));
          })
          .catch((error) => {
            alert('error ' + JSON.stringify(error));
          });
      })
      .catch((error) => {
        alert('error' + JSON.stringify(error));
      });
  }
 


   /**
 * 打开文件
 * @param fileUrl 文件地址 https://xxxxxxxx.com.cn/xx.pdf
 * @param target 文件类型,默认为"application/pdf";
 */
NewOpenFile(fileUrl:string,target:string="application/pdf"){
  let that = this;
  debugger;
      let transfer = new FileTransfer();
      const fileTransfer:FileTransferObject = transfer.create();
      //const apk = this.file.externalRootDirectory + 'android.apk'; //apk保存的目录
      
      let fileupload:any =fileUrl;
      let index:number= fileUrl.lastIndexOf("\/")+1;
      let filesname = fileUrl.substring(index,fileUrl.length);//获取文件名称
      let apk = that.file.externalDataDirectory + filesname;
      let headers = {};
          headers["Content-type"]="application/octet-stream";
          headers["Content-Disposition"]="attachment;filename="+filesname;
           that.DownLoadFileOpen(fileupload,apk,headers,target);
           
          // that.fileOpener.open(apk, target)
          // .then( success => {
          //   console.log( success,"文件打开成功" );
          // }, error => {
          //  that.DownLoadFileOpen(fileupload,apk,headers,target);
          //   console.log( error,"文件打开失败" );
          // })
          // .catch( error => {
          //   that.DownLoadFileOpen(fileupload,apk,headers,target);
          //   console.log( error,"文件打开失败Error" );
          // });


}

/**
 * 文件下载并打开
 * @param fileUrl 上传的文件绝对路劲 
 * @param appFile 硬盘文件路劲
 * @param headers 头部文件
 * @param target 文件mintype类型
 */
DownLoadFileOpen(fileUrl:string,appFile:string,headers:any={},target:string="application/pdf"){
    const that =this;
  let transfer = new FileTransfer();
      const fileTransfer:FileTransferObject = transfer.create();
  that.msg.Loading("下载进度：0%").then((loads:HTMLIonLoadingElement)=>{
    console.log(fileUrl,"打开文件前");
  fileTransfer.download(fileUrl,appFile,true,headers ).then(( datas ) => {
    console.log(datas,"下载完文件地址");
  that.msg.Show("下载完文件地址");
  
    that.fileOpener.open(datas.nativeURL, target)
      .then( success => {
        loads.dismiss();
        console.log( success );
      }, error => {
        loads.dismiss();
        console.log( error );
      })
      .catch( error => {
        loads.dismiss();
        that.msg.Alert(app.ERRORMESSAGE);
        console.log( error );
      } );
  }).catch( error => {
    loads.dismiss();
    that.msg.Alert(app.ERRORMESSAGE);
  });
console.log(loads);
  fileTransfer.onProgress(( event: ProgressEvent ) => {
    let num = Math.floor( event.loaded / event.total * 100 );
    if ( num === 100 )
    {
      loads.message = '下载完成准备打开中,请稍后';
      loads.dismiss();
    } else
    {
      //console.log(loads);
      let title = num;
      title && ( loads.message = '下载进度：' + num + '%' );
    }
  });
loads.present();
});
}
  
}


